var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMn = function SvgMn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 24c1.467 0 2.873-.263 4.173-.746l.522-11.253L16.173.747A11.975 11.975 0 0 0 12 .001c-1.468 0-2.874.264-4.174.746l-.521 11.254.521 11.253c1.3.483 2.706.747 4.174.747Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M0 12c0 5.16 3.256 9.558 7.826 11.254V.746C3.256 2.442 0 6.84 0 12ZM16.174.746v22.507C20.744 21.558 24 17.16 24 12 24 6.84 20.743 2.44 16.174.746Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M6.783 11.999H5.739v4.174h1.044v-4.174ZM2.609 11.999H1.565v4.174H2.61v-4.174ZM4.174 14.608a1.044 1.044 0 1 0 0-2.087 1.044 1.044 0 0 0 0 2.087ZM4.174 10.434a.522.522 0 1 0 0-1.044.522.522 0 0 0 0 1.044ZM5.218 15.129H3.13v1.043h2.087V15.13ZM5.218 10.955H3.13V12h2.087v-1.044ZM4.175 6.26l.37 1.137H5.74l-.967.703.369 1.137-.967-.703-.968.703.37-1.137-.968-.703h1.196l.37-1.137Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMn;